import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import ro from 'vee-validate/dist/locale/ro.json';
import i18n from '../src/i18n';

const ibantools = require('ibantools');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('required', {
  ...rules.required,
  message: (field, a) => {
    if (field === 'judet') {
      return 'Inregistrarea judetului este obligatorie'
    } else if (field === 'localitate') {
      return 'Inregistrarea localitatii este obligatorie'
    }
    if (i18n.te(`validation.customRequired.${field}`)) {
      return i18n.t(`validation.customRequired.${field}`);
    }

    return i18n.t('validation.required', { field: i18n.t(field) });
  }
});
extend('requiredAdress', {
  ...rules.required,
  message: 'Inregistrarea adresei este obligatorie'
});
extend('requiredJudet', {
  ...rules.required,
  message: 'Inregistrarea judetului este obligatorie'
});
extend('requiredLocal', {
  ...rules.required,
  message: 'Inregistrarea localitatii este obligatorie'
});
extend('min', {
  ...rules.length,
  message: (field, rule) => {    
    if (i18n.te(`validation.customLength.${field}`)) {
      return i18n.t(`validation.customLength.${field}`, { length: rule.length });
    }
    return `Este necesar un câmp cu minim 20 max 200 de caractere pentru răspunsul utilizatorului`;
  }
});
extend('max', {
  ...rules.length,
  message: (field, rule) => {    
    if (i18n.te(`validation.customLength.${field}`)) {
      return i18n.t(`validation.customLength.${field}`, { length: rule.length });
    }
    return `Este necesar un câmp cu minim 20 max 200 de caractere pentru răspunsul utilizatorului`;
  }
});
extend('length', {
  ...rules.length,
  message: (field, rule) => {
    if (field === 'Cod postal') {
      return `Codul postal trebuie sa fie format din ${rule.length} cifre`
    }
    if (i18n.te(`validation.customLength.${field}`)) {
      return i18n.t(`validation.customLength.${field}`, { length: rule.length });
    }
    return `The ${field} must be numeric and contains exactly ${rule.length} digits`;
  }
});

extend('integer', {
  ...rules.integer,
  message: (field, rule) => {
    if (field === 'Cod postal') {
      return `Codul postal trebuie sa fie format din 6 cifre`
    }
    if (i18n.te(`validation.customInteger.${field}`)) {
      return i18n.t(`validation.customInteger.${field}`);
    }

    return `${field} is not valid`;
  }
});

extend('alpha', {
  ...rules.alpha,
  message: (field, rule) => {
    if (i18n.te(`validation.customAlpha.${field}`)) {
      return i18n.t(`validation.customAlpha.${field}`);
    }

    return `${field} is not valid`;
  }
});

extend('email', {
  ...rules.email,
  message: i18n.t('validation.email')
});

extend('confirmed', {
  ...rules.confirmed,
  message: 'Adresa de email nu coincide'
});

extend('password', {
  validate: value => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W]{8,}$/.test(value),
  message: 'Das Passwort muss eine Mindestlänge von 8 Zeichen haben und mindestens einen Buchstaben und eine Zahl enthalten'
});

extend('plz', {
  validate: value => /^(\d{4})?$/.test(value) || /^(\d{5})?$/.test(value),
  message: 'Die Postleitzahl kann nur 4 bis 5 Ziffern haben'
});

extend('hausnr', {
  validate: value => /^[a-zA-Z0-9-\s/]+$/.test(value),
  message: 'Hausnummer ist ungültig'
});

extend('adress', {
  validate: value => /^[a-zA-ZăĂîÎșȘțȚâÂ0-9-,.\s/]+$/.test(value),
  message: 'Introduceți adresa completă'
});

extend('iban', {
  validate: value => {
    const countryCode = value.substring(2, 0)
    const isIban =ibantools.isValidIBAN(value.replace(/ /ig, ''))
    return isIban&&countryCode==='RO'
  },
  message: 'Codul IBAN introdus nu este valid'
});

extend('ibanCountries', {
  validate: (value, countries) => {
    if (countries.length) {
      const countryCode = value.substring(0, 2)
      return countries.includes(countryCode)
    }
  },
  message: 'Codul IBAN introdus nu este valid'
});
extend('romaIban', {
  validate: (value) => {
    const countryCode = value.substring(2, 0)
    return countryCode === "RO"
  },
  message: 'Codul IBAN introdus nu este valid'
});
extend('bic', {
  validate: value => !!ibantools.isValidBIC(value),
  message: 'BIC ist ungültig'
});

extend('phonePrefix', {
  validate: value => /^[0-9]{1,3}$/.test(value),
  message: 'Prefix ist ungültig'
});

extend('street', value => {
  return /^[a-zA-Z\s.-]+$/.test(value);
});

extend('location', value => {
  return /^[a-zA-Z\s-]+$/.test(value);
});

extend('onlyLetters', {
  validate: (value) => /^[a-zA-Z ăĂîÎșȘțȚâÂ-]+$/.test(value),
  message: 'Doar literele sunt acceptate'
});

extend('phoneNumber', {
  ...rules.digits,
  validate: value => /^07[0-9]{8}$|^202000000[1-6]{1}$/.test(value),
  message: (field, rule) => {
    return i18n.t(`validation.customPhoneNumber.${field}`, { digits: rule.digits });
  }
});

// let wihtCustomMessages = {
//   ...de.messages,
//   length: (input, { length }) => `${input} muss eine ${length}-stellige Zahl sein`
// }

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule] // copies rule configuration
    // message: wihtCustomMessages[rule] // assign message
  });
});


localize({
  ro: {
    messages: ro.messages
  }
});
let LOCALE = "ro";


// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
  get() {
    return LOCALE;
  },
  set(val) {
    LOCALE = val;
    localize(val);
  }
});
